import styled from 'styled-components';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { CloudImage } from '@components/CloudImage';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

const WIDTH_BRAND_TEXT_MOBILE = '550px';
const PADDING_MOBILE_CONTAINER = '88px';
const BRAND_CONTAINER_SPACING_GAP = '56px';
const BRAND_CONTAINER_SPACING_DESKTOP = '124px';
const BRAND_DESKTOP_SIZE = 70;

export const Container = styled(Flex)`
  width: 100%;
  flex-direction: column;
  background-color: ${themeColor('yellow1')};
  gap: ${BRAND_CONTAINER_SPACING_GAP};
  padding-top: ${PADDING_MOBILE_CONTAINER};
  padding-bottom: ${themeSpace(10)};
  ${themeMediaQuery('tablet')} {
    padding-bottom: ${themeSpace(11)};
  }
  ${themeMediaQuery('md')} {
    gap: ${BRAND_CONTAINER_SPACING_DESKTOP};
    padding: ${BRAND_CONTAINER_SPACING_DESKTOP} 0;
  }
`;

export const StyledText = styled(Text)`
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    max-width: ${WIDTH_BRAND_TEXT_MOBILE};
  }
  ${themeMediaQuery('sm')} {
    max-width: 82%;
  }
  ${themeMediaQuery('md')} {
    max-width: 60%;
  }
  ${themeMediaQuery('lg')} {
    max-width: 49%;
  }
`;

export const TextWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: ${themeSpace(9)};
  ${themeMediaQuery('below_sm')} {
    padding: 0 ${themeSpace(6)};
    gap: ${BRAND_CONTAINER_SPACING_GAP};
  }
`;

export const BrandsWrapper = styled(Flex)`
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  padding: 0 ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    flex-wrap: wrap;
    gap: ${themeSpace(9)};
    padding: 0 ${themeSpace(5)};
  }
  ${themeMediaQuery('sm')} {
    transform: scale(0.75);
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
  }
`;

export const MobileBrandLogo = styled(CloudImage)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const DesktopBrandLogo = styled(CloudImage)`
  height: ${BRAND_DESKTOP_SIZE}px;
  width: 'auto';
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const BrandItemWrapper = styled(Flex)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: center;
  width: fit-content;
  row-gap: ${themeSpace(10)};
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    row-gap: ${themeSpace(9)};
  }
`;
